var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"150px","height":"150px","margin":"auto"}},[_c('v-img',{staticClass:"mx-auto partner-logo",attrs:{"width":"150","height":"150","alt":`${_vm.partnerSettings.partnerName} logo`,"src":_vm.partnerSettings.logoUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }